module.exports = __webpack_public_path__ + "static/media/ybs.74c9ae7e.svg";